module.exports = __webpack_public_path__ + "public/Icons/manage_drivers.svg?1f02a5c2";